// Bundle Stimulus Core - Chargé une seule fois globalement
// Évite la duplication de Stimulus dans tous les bundles
// Doit être chargé AVANT tous les autres bundles JavaScript

import { Application, Controller } from "@hotwired/stimulus"
import "@hotwired/turbo-rails"

// Configuration Stimulus globale
const application = Application.start()
application.debug = false

// Expose Stimulus et Controller globalement pour les autres bundles
window.Stimulus = application
window.StimulusApplication = Application
window.StimulusController = Controller

// Export pour les autres bundles
export { application, Application, Controller }